import Header from '@components/Comman/Header'
import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import BusinessCategoryTable from './BusinessCategoryTable';
import PageTitle from '@components/Comman/PageTitle';
import { addBusinessCategories, getAllBusinessCategories, updateBusinessCategories } from '../../actions/business';

const BusinessCategory = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [showCategoryModel, setShowCategoryModel] = useState(false)
    const [initData, setInitData] = useState<any>();
    const onFinish = (values: any) => {
        let payload:any = {
            category: values?.label,
        }
        if(initData?.id) {
            payload.id = initData?.id
            dispatch(
                updateBusinessCategories(payload,(resp: any) => {
                    if (resp) {
                        setShowCategoryModel(false);
                        getAllBusinessCategories({}, (resp: any) => {})
                    }
                })
            );

        } else {
            dispatch(
                addBusinessCategories(payload,(resp: any) => {
                    if (resp) {
                        setShowCategoryModel(false);
                        getAllBusinessCategories({}, (resp: any) => {})
                    }
                })
            );
        }
    };



    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };
    return (
        <div>
            <Header pagTitle="Business Category" />
            <div className='contentBody'>
                <div className="bodycard">
                    <PageTitle 
                        buttonLabel={`Add Category`} 
                        isSuperAdmin={true} 
                        pagTitle={`Add/Update business categories`} 
                        button={true} 
                        buttonClick={()=> {setShowCategoryModel(true); form.setFieldsValue({label: ''});  setInitData({});}} 
                    />
                    <div className="cardContentbody">
                        <Modal
                            title={initData?.id ? `Update Category` : `Add Category`}
                            open={showCategoryModel}
                            onOk={() => setShowCategoryModel(!showCategoryModel)}
                            onCancel={() => {
                                form.setFieldsValue({label: ''})
                                setShowCategoryModel(false);
                            }}
                            footer={false}
                            >
                            <div>
                                <Form
                                    className="formControl"
                                    layout="vertical"
                                    form={form}
                                    onFinish={onFinish}
                                    onFinishFailed={onFailed}
                                    initialValues={{
                                        label: initData?.category
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-lg-12 col-sm-12">
                                            <Form.Item
                                                className="formControlDesign"
                                                label="Business Category"
                                                name="label"
                                                rules={[{ required: true, message: 'Please input your business category!' }]}
                                            >
                                                <Input placeholder='Enter Category' />
                                            </Form.Item>
                                        </div>
                                        <div className="col-lg-12 mt-15">
                                            <div className="text-end btn-groups-Forms">
                                                <button className="btn btn-outline-primary" onClick={() => {form.setFieldsValue({label: ''}); setShowCategoryModel(false)}}>
                                                    Cancel
                                                </button>
                                                <Button className="btn btn-primary" type='primary' onClick={() => form.submit()}>
                                                    {initData?.id ? "Update" : "Add"}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </Modal>
                    </div>
                    <BusinessCategoryTable 
                        handleUpdate={(value:any)=> {
                            // onFinish(value)
                        }} 
                        handleEdit={(record:any)=> {
                            setInitData(record);
                            form.setFieldsValue({label: record?.label})
                            setShowCategoryModel(true);
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default BusinessCategory